<template>
  <section>
    {{ result }}
  </section>
</template>
<script>
export default {
  name: 'get_route_line',

  data () {
    return {
      route_id: null,
      result: '',
    }
  },

  mounted () {
    this.api();
  },

  methods: {
    //데이터 가져오기
    api: function(){
      var url_string = window.location.href;
      var url = new URL(url_string);
      this.route_id = url.searchParams.get("route_id");
      if(this.route_id == null) {
        return;
      }

      var post_data = {route_id: this.route_id}
      this.$axios.post('/api/api_get_route_line', post_data).then(res => {
        this.result = res.data.result[0];
      });
    },
  },
}
</script>
<style>
</style>